<template>
  
  <div class="double-image-label u-pad-x-1of12 u-pad-y-xl u-pad-y-md--sm">
    <div class="u-row u-top u-left" :class="data.image1.length && data.image2.length && data.image3.length ? 'u-between' : 'u-evenly'">
      <div v-if="data.image1.length" class="u-w3of10 u-w12of12--sm u-pad-r-md u-pad-r-0--sm u-marg-b-md--sm">
        <div class="u-box-9by16">
          <template v-if="!isVideo(data.image1[0].extension)">
            <app-image :id="data.image1[0].id" :src="data.image1[0].url" :width="400 * 2" :height="710 * 2" class="u-block u-wrapper-panel u-fit-cover" />
          </template>
          <template v-else>
            <video-player :src="data.image1[0].url" :poster="data.mediaPreview1[0].url" class="u-wrapper-panel u-fit-cover" />
          </template>
        </div>
          <p class="t-h4 u-blue u-marg-t-md">
            {{ data.titre1 }}
          </p>
          <p class="t-text u-marg-t-md">
            {{ data.text1 }}
          </p>
      </div>
      <div v-if="data.image2.length" class="u-w3of10 u-w12of12--sm u-pad-l-md u-pad-l-0--sm u-marg-b-md--sm">
        <div class="u-box-9by16">
          <template v-if="!isVideo(data.image2[0].extension)">
            <app-image :id="data.image2[0].id" :src="data.image2[0].url" :width="400 * 2" :height="710 * 2" class="u-block u-wrapper-panel u-fit-cover" />
          </template>
          <template v-else>
            <video-player :src="data.image2[0].url" :poster="data.mediaPreview2[0].url" class="u-wrapper-panel u-fit-cover" />
          </template>
        </div>
          <p class="t-h4 u-blue u-marg-t-md">
            {{ data.titre2 }}
          </p>
          <p class="t-text u-marg-t-md">
            {{ data.text2 }}
          </p>
      </div>
      <div v-if="data.image3.length" class="u-w3of10 u-w12of12--sm u-pad-l-md u-pad-l-0--sm u-marg-b-md--sm">
        <div class="u-box-9by16">
          <template v-if="!isVideo(data.image3[0].extension)">
            <app-image :id="data.image3[0].id" :src="data.image3[0].url" :width="400 * 2" :height="710 * 2" class="u-block u-wrapper-panel u-fit-cover" />
          </template>
          <template v-else>
            <video-player :src="data.image3[0].url" :poster="data.mediaPreview3[0].url" class="u-wrapper-panel u-fit-cover" />
          </template>
        </div>
          <p class="t-h4 u-blue u-marg-t-md">
            {{ data.titre3 }}
          </p>
          <p class="t-text u-marg-t-md">
            {{ data.text3 }}
          </p>
      </div>
    </div>
  </div>
</template>

<script>

import VideoPlayer from '@/components/VideoPlayer'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  components: {
    VideoPlayer
  },

  methods: {
    isVideo (extension) {
      let fileType = extension.toLowerCase()

      if(fileType !== 'png' && fileType !== 'jpeg' && fileType !== 'jpg' && fileType !== 'gif') {
        return true
      }
      else {
        return false
      }
    }
  }
}
</script>